<template>
  <div class="agent-practice">
    <sub-title title="学习成长"></sub-title>
    <AgentDesc avatar-index="zhang" name="陪练助手"></AgentDesc>
    <div class="agent-practice-body">
      <div
        v-for="item in cardList"
        :key="item.id"
        class="session-card"
        :class="{
          'info-card': item.type === 1,
          'err-card': item.type === 3,
          'warring-card': item.type === 2
        }"
        @click="handleClickCard(item)"
      >
        <i class="icon-information-line prefix-icon t-iconfont"></i>
        <div class="session-card__main">
          <div class="title">{{ item.title }}</div>
          <div class="desc">
            <span>{{ item.desc }}（截止至</span>
            <span class="time"> {{ item.time }} </span>
            <span>）</span>
          </div>
        </div>
        <i class="icon-arrow-right-line subfix-icon t-iconfont"></i>
      </div>
    </div>
  </div>
</template>

<script setup>
import subTitle from './components/sub-title.vue'
import AgentDesc from './components/agent-desc.vue'
import { computed } from 'vue'
import xbb from '@xbb/xbb-utils'

const props = defineProps({
  trainingList: {
    type: Array,
    default: () => []
  }
})

const emits = defineEmits(['openPractice'])

const cardList = computed(() => {
  return props.trainingList.map((item) => {
    const typeEnum = {
      1: '待完成',
      2: '即将逾期',
      3: '已逾期'
    }
    return {
      id: item.id,
      type: item.type,
      title: `你有 ${item.num} 条学习任务${typeEnum[item.type]}`,
      desc: item.name,
      time: xbb.formatTime(item.time, 'yyyy-MM-dd HH:mm'),
      isView: item.isView
    }
  })
})

const handleClickCard = (item) => {
  emits('openPractice', item)
}
</script>

<style lang="scss" scoped>
.agent-practice {
  display: flex;
  flex-direction: column;
  position: relative;
  margin-bottom: 16px;
  &-body {
    flex: 1;
    padding-left: 32px;
    display: flex;
    flex-direction: column;
    position: relative;
    .session-card {
      border-radius: 16px;
      background: #ffffff;
      padding: 12px;
      box-shadow: 0px 2px 30px 2px rgba(0, 0, 0, 0.05);
      display: flex;
      align-items: center;
      margin-bottom: 8px;
      .prefix-icon {
        flex: 0 0 auto;
        font-size: 18px;
        margin-right: 12px;
      }
      .subfix-icon {
        flex: 0 0 auto;
        font-size: 18px;
        margin-left: 12px;
        color: #969799;
        cursor: pointer;
      }
      .session-card__main {
        flex: 1;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        .title {
          font-size: 14px;
          line-height: 20px;
          font-weight: 600;
          color: #323233;
          margin-bottom: 4px;
        }
        .desc {
          span {
            font-size: 12px;
            line-height: 16px;
            color: #646566;
          }
        }
      }
    }
    .info-card {
      border: 1px solid #e8f7ff;
      .prefix-icon {
        color: #248df5;
      }
    }
    .err-card {
      border: 1px solid #ffece8;
      .prefix-icon {
        color: #f54e4e;
      }
      .session-card__main {
        .desc {
          .time {
            color: #f54e4e;
          }
        }
      }
    }
    .warring-card {
      border: 1px solid #fffbe8;
      .prefix-icon {
        color: #ffb521;
      }
      .session-card__main {
        .desc {
          .time {
            color: #ffb521;
          }
        }
      }
    }
  }
}
</style>
